import { UILightColor } from '@kite-js/theme-types';

const lightScale: UILightColor = {
    20: '#F7F7F7',
    50: '#D5D7DB',
    100: '#DDDFE2',
    150: '#CED0D4',
    200: '#757575',
    300: '#757575',
    500: '#333333',
    800: '#000000',
};

export default lightScale;
